module.exports = __webpack_public_path__ + "img/rnd5.286af48d.jpg";